'use client'

import React, { useState, useMemo } from 'react'
import { Typography } from 'components/Contentful/Typography/Typography'
import { StarRating } from '../StarRating'
import { MediaImageStandard } from '../Contentful'
import { AchieveLink } from '../AchieveLink'
import { BillsRatingModal } from 'components/BillsRatingModal/BillsRatingModal'
import { withUuid } from 'utils/shared'

export const ProviderCompare = ({ items = [] }) => {
  const [modalStatus, setModalStatus] = useState(false)
  const itemsList = useMemo(() => withUuid(items), [items])
  return (
    <div className="flex flex-col gap-4 my-10 scroll-mt-[100px]" id="article-compare-section">
      <Typography content={'Compare to leading providers'} className="headingMd font-medium!" />
      <div className="flex flex-col lg:flex-row gap-4">
        {itemsList.map(({ fields, uuid }) => (
          <div
            key={uuid}
            className="w-full lg:w-[320px] rounded-md border-[0.5px] border-solid border-gray-200"
          >
            <div className="flex flex-col gap-2 p-5">
              <div className="flex flex-row gap-2 items-center relative justify-between">
                <MediaImageStandard
                  content={fields?.logoImage}
                  layout="fixed"
                  className="w-[95px] h-auto"
                />
                <AchieveLink href={`/${fields?.slug}`} target="_blank">
                  <Typography
                    content={'Read Review'}
                    className="displayXs cursor-pointer font-light! underline text-black text-end"
                  />
                </AchieveLink>
              </div>
              <div className="flex flex-row gap-2 items-center">
                <Typography content={`${fields?.overallRating}/5`} className="bodyMd" />
                <StarRating
                  rating={Number(fields?.overallRating)}
                  size={18}
                  startColor="text-[#3d6feb]"
                />
              </div>
              <Typography
                content={'Bills.com rating'}
                className="bodyXs cursor-pointer text-blue-500 underline"
                onClick={() => {
                  setModalStatus(true)
                }}
              />
            </div>
            <div className="flex flex-col gap-6 p-5 border-0 border-t-[0.5px] border-solid border-gray-200">
              {fields.bestTitle && (
                <div className="flex flex-col gap-3">
                  <Typography content={'Good for:'} className="bodySm underline" />
                  <Typography
                    content={fields.bestTitle.replace('Best for', '')}
                    className="bodySm"
                  />
                </div>
              )}

              {fields.provider?.fields?.fixedApr && (
                <div className="flex flex-col gap-1">
                  <Typography content={'Fixed Rate'} className="displayXs font-light!" />
                  <Typography
                    content={`${fields.provider?.fields?.fixedApr}%`}
                    className="bodyMd font-bold!"
                  />
                </div>
              )}
              {fields.provider?.fields?.repayment && (
                <div className="flex flex-col gap-1">
                  <Typography content={'Loan Term'} className="displayXs font-light!" />
                  <Typography
                    content={`${fields.provider?.fields?.repayment}`}
                    className="bodyMd font-bold!"
                  />
                </div>
              )}
              {fields.provider?.fields?.loanAmounts && (
                <div className="flex flex-col gap-1">
                  <Typography content={'Loan Amount'} className="displayXs font-light!" />
                  <Typography
                    content={`${fields.provider?.fields?.loanAmounts}%`}
                    className="bodyMd font-bold!"
                  />
                </div>
              )}
              {fields.provider?.fields?.minCreditScore && (
                <div className="flex flex-col gap-1">
                  <Typography content={'Min. Credit Score'} className="displayXs font-light!" />
                  <Typography
                    content={`${fields.provider?.fields?.minCreditScore}`}
                    className="bodyMd font-bold!"
                  />
                </div>
              )}

              {fields.provider?.fields?.debtSettled && (
                <div className="flex flex-col gap-1">
                  <Typography content={'Debt Settled'} className="bodySm" />
                  <Typography
                    content={fields.provider?.fields?.debtSettled}
                    className="displayXs"
                  />
                </div>
              )}
              {fields.provider?.fields?.programLength && (
                <div className="flex flex-col gap-1">
                  <Typography content={'Program Length'} className="bodySm" />
                  <Typography
                    content={fields.provider?.fields?.programLength}
                    className="displayXs"
                  />
                </div>
              )}
              {fields.provider?.fields?.customerSupport && (
                <div className="flex flex-col gap-1">
                  <Typography content={'Customer Support'} className="bodySm" />
                  <Typography
                    content={fields.provider?.fields?.customerSupport}
                    className="displayXs"
                  />
                </div>
              )}
              {fields.provider?.fields?.accreditation && (
                <div className="flex flex-col gap-1">
                  <Typography content={'Accreditation'} className="bodySm" />
                  <Typography
                    content={fields.provider?.fields?.accreditation}
                    className="displayXs"
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <BillsRatingModal modalStatus={modalStatus} setModalStatus={setModalStatus} />
    </div>
  )
}

export default ProviderCompare
